import OnboardingTourContext from 'Contexts/OnboardingTourContext';
import { useContext } from 'react';

const useOnboardingTour = () => useContext(OnboardingTourContext);

export default useOnboardingTour;
